import { FFmpeg } from "@ffmpeg/ffmpeg";
import { fetchFile, toBlobURL } from "@ffmpeg/util";

const ffmpeg = new FFmpeg();

let ffmpegLoaded = false;
let loadingPromise = null;

const loadFFmpeg = async () => {
  if (ffmpegLoaded) {
    return;
  }

  if (loadingPromise) {
    return loadingPromise;
  }

  loadingPromise = (async () => {
    const baseURL =
      "https://unpkg.com/@ffmpeg/core@0.12.10/dist/umd";

    await ffmpeg.load({
      coreURL: await toBlobURL(
        `${baseURL}/ffmpeg-core.js`,
        "text/javascript"
      ),
      wasmURL: await toBlobURL(
        `${baseURL}/ffmpeg-core.wasm`,
        "application/wasm"
      ),
    });

    ffmpegLoaded = true;
  })();

  try {
    await loadingPromise;
  } finally {
    loadingPromise = null;
  }
};

export const convertOggToMp3 = async (url) => {
  await loadFFmpeg();

  const inputName = "input.ogg";
  const outputName = "output.mp3";

  await ffmpeg.writeFile(
    inputName,
    await fetchFile(url)
  );

  await ffmpeg.exec([
    "-i",
    inputName,
    "-codec:a",
    "libmp3lame",
    "-b:a",
    "128k",
    outputName,
  ]);

  const data = await ffmpeg.readFile(outputName);

  const blob = new Blob([data.buffer], {
    type: "audio/mpeg",
  });

  return URL.createObjectURL(blob);
};